<template>
	<div class="window window-new-study" v-if="app.window.name == 'window-new-study'">
		<div class="window-bg"></div>
		<div class="window-wrap">
			<div class="window-content">
				<div class="window-close" @click="close()"><icon file="x" /></div>
					
				<div class="window-title">
					<p class="title">{{ title }}</p>
					<p class="sub-title">Paramétrez la nouvelle étude</p>
				</div>


				<form-study :cols="2" />
				
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import FormStudy from "@/components/study/sidebar/form-study";

export default {
	name: "window-new-study",
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters([ "app", "new_study_for_active_project", "active_project" ]),
		title () {
			if (this.new_study_for_active_project) {
				return "Ajout d'une nouvelle étude au projet";
			}
			return "Création d'une nouvelle étude";
		},
	},
	methods: {
		close: function () {
			this.$store.dispatch("set_new_study_for_active_project", { value: false });
			this.$store.dispatch("set_window", { name: false });
		}
	},
	components: { FormStudy }
};
</script>


<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'
@import '../../assets/css/ui'
@import '../../assets/css/window'


.window.window-new-study
	.window-content
		width 800px
	
	.window-loader
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background alpha(#fff, 50%)
		border-radius radius
		color #666
		cursor progress
		.icon
			position absolute
			left 50%
			top 50%
			margin -32px 0 0 -32px
			animation rotate 1s infinite linear


</style>